import React, { useEffect, useState, useMemo } from 'react';
import Layouts from '../../components/Layouts';
import { getDirectusClient } from '../../lib/directus';
import {
  Button,
  Col,
  Form,
  Modal,
  Row,
  Select,
  Space,
  Table,
  Tabs,
  message,
  Typography,
  Alert,
  InputNumber,
} from 'antd';
import Seriales from './components/Seriales';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  createItem,
  readItems,
  readUsers,
  updateItem,
  updateUser,
} from '@directus/sdk';
import PorCaja from './components/PorCaja';
import PorCajaGrupo from './components/PorCajaGrupo';
import moment from 'moment'; // Replace dayjs import with moment
import CajaCloseModal from './components/CajaCloseModal';
import ConsignacionModal from './components/ConsignacionModal';
import {
  getInventarioNSPrestamosByVendedor,
  updateInventarioNSPrestamo,
} from '../../services/inventarioNSPrestamos';
import {
  EditInventarioNoSerial,
  getInventarioNoSerialById,
} from '../../services/inventarioNoSerial';
import { formatPrice } from '../../lib/utils';

const { Option } = Select;
const { Text } = Typography;
const arrayproductosfacturar = [];
function Factura(props) {
  const [vendedoresprestamo, setVendedoresprestamo] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 20,
    total: 0,
  });
  const signoMoneda = useSelector(state => state.signoMoneda.signo_moneda);

  const [vendedorprestamo, setVendedorprestamo] = useState('');
  const [totalfactura, setTotalfactura] = useState(0);
  const [productosvendedor, setProductosvendedor] = useState([]);
  const [productotabla, setProductotabla] = useState([]);
  const [precios, setPrecios] = useState([]);

  const user = useSelector(state => state.userdata.id);
  const userBodega = useSelector(state => state.userdata.bodega?.id);
  const [currentCajaId, setCurrentCajaId] = useState(null);
  const userRoleID = useSelector(state => state.userdata.role?.name);
  const [precioselect, setPrecioselect] = useState(0);
  const [productoselect, setProductoselect] = useState({});

  const [seriales, setSeriales] = useState([]);
  const [form] = Form.useForm();

  const navigate = useNavigate();

  const [vendedoresFactura, setVendedoresFactura] = useState([]);
  const [cajaAbierta, setCajaAbierta] = useState(false);

  // Add new state for final total
  const [totalConImpuestos, setTotalConImpuestos] = useState(0);

  // Add new state for clients
  const [clientes, setClientes] = useState([]);

  // Add new state at the top of the component
  const [tipoFactura, setTipoFactura] = useState([]);
  const [selectedTipoFactura, setSelectedTipoFactura] = useState(null);

  // Add new state for storing complete client data
  const [selectedClient, setSelectedClient] = useState(null);

  // Add new state for the modal
  const [isCajaCloseModalVisible, setIsCajaCloseModalVisible] = useState(false);

  // Add new state for discounts
  const [descuentos, setDescuentos] = useState([]);

  // Add new state for consignacion modal
  const [isConsignacionModalVisible, setIsConsignacionModalVisible] =
    useState(false);

  // Add new state for cantidad de productos no serializados
  const [cantidadNoSerializado, setCantidadNoSerializado] = useState(1);

  // Only depends on user being available

  // Update consultarVendedorprestamo function
  const consultarVendedorprestamo = async value => {
    const directus = await getDirectusClient();

    // 1. Consultar vendedores con productos serializados
    const response = await directus.request(
      readUsers({
        search: value,
        fields: [
          'id',
          'first_name',
          'last_name',
          'productos_prestados.id',
          'productos_prestados.nombre',
          'productos_prestados.preciosinimp',
          'productos_prestados.precios.*',
          'productos_prestados.seriales.*',
        ],
        filter: {
          role: {
            name: {
              _in: ['supervisor tropas', 'vendedor rutas', 'tropas'],
            },
          },
          ...(userRoleID !== 'adminapp' && userRoleID !== 'Administrator'
            ? { bodega: { id: { _eq: userBodega } } }
            : {}),
        },
      })
    );

    setVendedoresprestamo(response);
  };

  const consultarVendedorFactura = async value => {
    const directus = await getDirectusClient();
    const response = await directus.request(
      readUsers({
        search: value,
        fields: ['id', 'first_name', 'last_name'],
        filter: {
          role: {
            name: {
              _in: ['supervisor tropas', 'vendedor rutas', 'tropas'],
            },
          },
          ...(userRoleID !== 'adminapp' && userRoleID !== 'Administrator'
            ? {
                bodega: {
                  id: { _eq: userBodega },
                },
              }
            : {}),
        },
      })
    );
    setVendedoresFactura(response);
  };

  // Add new function to fetch clients
  const consultarClientes = async value => {
    if (!value) return; // If empty search, keep showing initial data

    const directus = await getDirectusClient();
    try {
      const response = await directus.request(
        readUsers({
          search: value,
          fields: ['id', 'first_name', 'last_name'],
          filter: {
            role: {
              name: {
                _in: [
                  'clientes',
                  'vendedor rutas',
                  'supervisor tropas',
                  'tropas',
                ],
              },
            },
            ...(userRoleID !== 'adminapp' && userRoleID !== 'Administrator'
              ? {
                  bodega: {
                    id: { _eq: userBodega },
                  },
                }
              : {}),
          },
          limit: 5,
        })
      );
      setClientes(response);
    } catch (error) {
      console.error('Error fetching clients:', error);
      message.error('Error al cargar los clientes');
    }
  };

  // Add this as a separate function
  const handleCajaValidation = cajas => {
    if (!cajas || cajas.length === 0) {
      Modal.confirm({
        title: 'Caja Cerrada',
        content: '¿Desea abrir su caja para el día de hoy?',
        okText: 'Sí, abrir caja',
        cancelText: 'No',
        onOk: () => handleCajaOpen(),
        onCancel: () => setCajaAbierta(false),
      });
      return;
    }

    const cajaActual = cajas[0];
    const cajaDate = moment(cajaActual.fecha_apertura).startOf('day');
    const today = moment().startOf('day');

    if (cajaDate.isBefore(today)) {
      Modal.confirm({
        title: 'Caja Anterior Abierta',
        content: 'Tiene una caja abierta del día anterior. ¿Desea cerrarla?',
        okText: 'Cerrar caja anterior',
        cancelText: 'Cancelar',
        onOk: async () => {
          try {
            const directus = await getDirectusClient();
            await directus.request(
              updateItem('cajas', cajaActual.id, {
                estado: 2,
                fecha_cierre: moment().toISOString(),
              })
            );

            message.success('Caja anterior cerrada exitosamente');
            Modal.confirm({
              title: 'Abrir Nueva Caja',
              content: '¿Desea abrir su caja para el día de hoy?',
              okText: 'Sí, abrir caja',
              cancelText: 'No',
              onOk: () => handleCajaOpen(),
              onCancel: () => setCajaAbierta(false),
            });
          } catch (error) {
            console.error('Error cerrando caja anterior:', error);
            Modal.error({
              title: 'Error',
              content: 'No se pudo cerrar la caja anterior',
            });
          }
        },
      });
      setCajaAbierta(false);
    } else {
      setCajaAbierta(true);
    }
  };

  // Simplify useEffect to only fetch data
  useEffect(() => {
    const fetchCajaStatus = async () => {
      try {
        const directus = await getDirectusClient();
        const response = await directus.request(
          readItems('cajas', {
            fields: ['id', 'fecha_apertura', 'fecha_cierre', 'estado'],
            filter: {
              vendedor: {
                _eq: user,
              },
              estado: {
                _eq: 1,
              },
            },
            sort: ['-fecha_apertura'],
          })
        );
        if (response && response.length > 0) {
          setCurrentCajaId(response[0].id);
        }
        handleCajaValidation(response);
      } catch (error) {
        console.error('Error verificando caja:', error);
        Modal.error({
          title: 'Error',
          content: 'Error al verificar el estado de la caja',
        });
      }
    };

    if (user) {
      fetchCajaStatus();
    }
  }, [user]);

  // Add new useEffect to load initial clients
  useEffect(() => {
    const loadInitialClients = async () => {
      const directus = await getDirectusClient();
      try {
        const response = await directus.request(
          readUsers({
            fields: ['id', 'first_name', 'last_name'],
            filter: {
              role: {
                name: {
                  _in: [
                    'clientes',
                    'vendedor rutas',
                    'supervisor tropas',
                    'tropas',
                  ],
                },
              },
              ...(userRoleID !== 'adminapp' && userRoleID !== 'Administrator'
                ? {
                    bodega: {
                      id: { _eq: userBodega },
                    },
                  }
                : {}),
            },
            limit: 5, // Adjust this number based on your needs
          })
        );
        setClientes(response);
      } catch (error) {
        console.error('Error loading initial clients:', error);
        message.error('Error al cargar los clientes iniciales');
      }
    };

    if (user) loadInitialClients();
  }, [user]); // Empty dependency array means this runs once when component mounts

  // Add new useEffect to load initial vendors
  useEffect(() => {
    const loadInitialVendors = async () => {
      const directus = await getDirectusClient();
      try {
        // Load prestamo vendors
        const prestamoResponse = await directus.request(
          readUsers({
            fields: [
              'id',
              'first_name',
              'last_name',
              'productos_prestados.*',
              'productos_prestados.seriales.id',
              'productos_prestados.seriales.estado',
            ],
            filter: {
              role: {
                name: {
                  _in: ['supervisor tropas', 'vendedor rutas'],
                },
              },
              ...(userRoleID !== 'adminapp' && userRoleID !== 'Administrator'
                ? {
                    bodega: {
                      id: { _eq: userBodega },
                    },
                  }
                : {}),
            },
            limit: 5,
          })
        );
        setVendedoresprestamo(prestamoResponse);

        // Load factura vendors
        const facturaResponse = await directus.request(
          readUsers({
            fields: ['id', 'first_name', 'last_name'],
            filter: {
              role: {
                name: {
                  _in: ['supervisor tropas', 'vendedor rutas'],
                },
              },
              ...(userRoleID !== 'adminapp' && userRoleID !== 'Administrator'
                ? {
                    bodega: {
                      id: { _eq: userBodega },
                    },
                  }
                : {}),
            },
            limit: 5,
          })
        );
        setVendedoresFactura(facturaResponse);
      } catch (error) {
        console.error('Error loading initial vendors:', error);
        message.error('Error al cargar los vendedores iniciales');
      }
    };

    loadInitialVendors();
  }, [user]); // Empty dependency array means this runs once when component mounts

  // Add new function to fetch tipo_factura
  const fetchTipoFactura = async () => {
    try {
      const directus = await getDirectusClient();
      const response = await directus.request(
        readItems('tipo_factura', {
          fields: ['id', 'tipo'],
        })
      );
      setTipoFactura(response);
    } catch (error) {
      console.error('Error fetching tipo_factura:', error);
      message.error('Error al cargar los tipos de factura');
    }
  };

  // Add useEffect to load tipo_factura
  useEffect(() => {
    fetchTipoFactura();
  }, []);

  const handleCajaOpen = async () => {
    try {
      const directus = await getDirectusClient();
      const newCaja = await directus.request(
        createItem('cajas', {
          vendedor: user,
          fecha_apertura: moment().toISOString(),
          estado: 1,
          total_ventas: 0,
        })
      );

      if (newCaja) {
        setCurrentCajaId(newCaja.id);
        message.success('Caja abierta exitosamente');
        setCajaAbierta(true);
      }
    } catch (error) {
      console.error('Error abriendo caja:', error);
      Modal.error({
        title: 'Error',
        content: 'No se pudo abrir la caja',
      });
    }
  };

  // Add function to fetch discounts
  const fetchDescuentos = async vendedorId => {
    try {
      const directus = await getDirectusClient();
      const response = await directus.request(
        readItems('descuentos', {
          fields: [
            'id',
            'nombre',
            'descuento',
            'productos.id',
            'productos.nombre',
            'usuarios.directus_users_id.id',
          ],
          filter: {
            usuarios: {
              directus_users_id: {
                id: { _eq: vendedorId },
              },
            },
          },
        })
      );
      setDescuentos(response);
      return response;
    } catch (error) {
      console.error('Error fetching discounts:', error);
      return [];
    }
  };

  // Update seleccionarvendedorprestamo function
  const seleccionarvendedorprestamo = async ev => {
    const vendedor = vendedoresprestamo.find(item => item.id === ev);

    // Limpiar el array de productos a facturar
    arrayproductosfacturar.length = 0;
    setProductotabla([]); // Limpiar la tabla
    setTotalfactura(0); // Resetear el total
    setTotalConImpuestos(0); // Resetear el total con impuestos

    // 1. Fetch discounts for this vendor
    const vendorDiscounts = await fetchDescuentos(ev);

    // 2. Fetch non-serialized products for this vendor
    const prestamosNoSerializados = await getInventarioNSPrestamosByVendedor(
      ev
    );
    const productosNoSerializados = await Promise.all(
      prestamosNoSerializados.map(async prestamo => {
        const productos = await getInventarioNoSerialById(
          prestamo?.inventario_ns?.id
        );
        if (!productos || productos.length === 0) {
          console.error('No se encontraron productos no serializados');
          return null;
        }

        // Procesar todos los productos (ejemplo: devolver un array de objetos)
        const noSerializados = productos.map(primerProducto => ({
          id: primerProducto.producto.id,
          nombre: primerProducto.nombre,
          precio: primerProducto.producto.preciosinimp,
          precios: primerProducto.producto?.precios || [],
          esNoSerializado: true,
          cantidad: prestamo.cantidad,
          estado: prestamo.estado,
          grupo: {
            impuesto: primerProducto.producto?.grupo?.impuesto || '0',
          },
        }));

        return noSerializados;
      })
    ).then(results => {
      // Filtrar resultados nulos y aplanar el array
      const productosAplanados = results.filter(Boolean).flat();

      // Agrupar por ID y sumar cantidades
      const productosAgrupados = productosAplanados.reduce((acc, producto) => {
        if (!acc[producto.id]) {
          acc[producto.id] = { ...producto };
        } else {
          // Convertir las cantidades a números antes de sumar
          const cantidadActual = parseInt(acc[producto.id].cantidad) || 0;
          const cantidadNueva = parseInt(producto.cantidad) || 0;
          acc[producto.id].cantidad = (
            cantidadActual + cantidadNueva
          ).toString();
        }
        return acc;
      }, {});

      // Convertir el objeto agrupado de vuelta a array
      return Object.values(productosAgrupados);
    });

    // 3. Verificar seriales con estado 1 o 3 para cada producto
    const directus = await getDirectusClient();
    const serialesResponse = await directus.request(
      readItems('seriales', {
        fields: [
          'bodega',
          'estado',
          'id',
          'caja',
          'user',
          'serial',
          'producto.grupo.impuesto',
          'producto.id',
          'producto.grupo.impuesto',
          'producto.nombre',
          'producto.preciosinimp',
          'producto.precios.precio',
          'producto.precios.alias',
        ],
        filter: {
          _and: [
            {
              user: {
                id: { _eq: ev },
              },
            },
            {
              estado: {
                id: { _in: [1, 3] },
              },
            },
            { producto: { _nnull: true } },
          ],
        },
        limit: -1,
      })
    );

    // 4. Procesar los seriales y agrupar por producto
    const productosConSeriales = serialesResponse.reduce((acc, serial) => {
      const productoId = serial?.producto?.id;
      if (!acc[productoId]) {
        acc[productoId] = {
          id: productoId,
          nombre: serial?.producto?.nombre,
          precio: serial?.producto?.preciosinimp,
          precios: serial?.producto?.precios || [],
          esNoSerializado: false,
          seriales: [],
          grupo: {
            impuesto: serial?.producto?.grupo?.impuesto || '0',
          },
        };
      }
      acc[productoId].seriales.push(serial);
      return acc;
    }, {});

    // 5. Convertir el objeto a array y combinar con productos no serializados
    const filteredProducts = [
      ...Object.values(productosConSeriales),
      ...productosNoSerializados.flat().filter(Boolean),
    ];

    // 6. Actualizar estados
    setVendedorprestamo(vendedor);
    setProductosvendedor(filteredProducts);
    setDescuentos(vendorDiscounts);

    // 7. Resetear selección actual
    form.resetFields(['producto', 'precios']);
    setProductoselect({});
    setPrecios([]);
    setPrecioselect(null);
  };

  const selecionadoproducto = async ev => {
    if (!ev) return;

    const pro = productosvendedor.find(item => item.id === ev);

    form.resetFields(['precios']);
    setPrecioselect(null);

    if (!pro) return;

    if (pro.esNoSerializado) {
      setProductoselect({
        ...pro,
        id: pro.id,
        nombre: pro.nombre,
        precio: parseFloat(pro.precio || 0),
        esNoSerializado: true,
        grupo: {
          impuesto: pro.grupo?.impuesto || '0',
        },
      });

      // Configurar los precios disponibles incluyendo precios del array precios
      const preciosDisponibles = [
        {
          precio: parseFloat(pro.precio || 0),
          alias: 'Precio Base',
          estado: true,
        },
      ];

      // Agregar precios del array precios si existen
      if (pro.precios && Array.isArray(pro.precios)) {
        pro.precios.forEach((precioObj, index) => {
          if (precioObj.precio) {
            preciosDisponibles.push({
              precio: parseFloat(precioObj.precio),
              alias: precioObj.alias,
              estado: true,
            });
          }
        });
      }

      setPrecios(preciosDisponibles);
    } else {
      // Para productos serializados
      const precioBase = parseFloat(pro.precio || 0);
      setProductoselect({
        ...pro,
        esNoSerializado: false,
        precio: precioBase,
      });

      // Configurar los precios disponibles incluyendo precios del array precios
      const preciosDisponibles = [
        {
          precio: precioBase,
          alias: 'Precio Base',
          estado: true,
        },
      ];

      // Agregar precios del array precios si existen
      if (pro.precios && Array.isArray(pro.precios)) {
        pro.precios.forEach((precioObj, index) => {
          if (precioObj.precio) {
            preciosDisponibles.push({
              precio: parseFloat(precioObj.precio),
              alias: precioObj.alias,
              estado: true,
            });
          }
        });
      }

      setPrecios(preciosDisponibles);
    }
  };

  // Modify selectprecio function to correctly apply discounts
  const selectprecio = ev => {
    const newPrice = parseFloat(ev);
    setPrecioselect(newPrice);

    // Update only the current product's price
    if (productoselect && productoselect.id) {
      const existingProduct = arrayproductosfacturar.find(
        item => item.producto.id === productoselect.id
      );

      if (existingProduct) {
        existingProduct.precio = newPrice;
        // Find discount for this specific product
        const discount = descuentos.find(
          d => d.productos && d.productos.id === productoselect.id
        );

        if (discount) {
          existingProduct.descuento = parseFloat(discount.descuento);
        }
      }
    }

    updateTableData();
  };

  const [loading, setLoading] = useState(false);

  const consultarserialesvendedor = async (productId = null, limit = 20) => {
    setLoading(true);
    try {
      const directus = await getDirectusClient();
      const countResponse = await directus.request(
        readItems('seriales', {
          filter: {
            _and: [
              {
                user: {
                  id: { _eq: vendedorprestamo.id },
                },
              },
              {
                producto: {
                  id: { _eq: productId || productoselect.id },
                },
              },
              {
                estado: {
                  id: { _in: [1, 3] },
                },
              },
              {
                ...(userRoleID !== 'adminapp' && userRoleID !== 'Administrator'
                  ? {
                      bodega: {
                        id: { _eq: userBodega },
                      },
                    }
                  : {}),
              },
            ],
          },
          aggregate: {
            countDistinct: ['id'],
          },
        })
      );
      const total = parseInt(countResponse[0]?.countDistinct?.id || 0);
      const response = await directus.request(
        readItems('seriales', {
          fields: [
            'bodega',
            'estado',
            'id',
            'caja',
            'user',
            'serial',
            'producto.grupo.impuesto',
            'producto.id',
            'producto.grupo.impuesto',
            'producto.nombre',
            'producto.preciosinimp',
            'producto.precios.precio',
          ],
          limit: limit,
          page: limit === -1 ? 1 : pagination.current,
          filter: {
            _and: [
              {
                user: {
                  id: { _eq: vendedorprestamo.id },
                },
              },
              {
                producto: {
                  id: { _eq: productId || productoselect.id },
                },
              },
              {
                estado: {
                  id: { _in: [1, 3] },
                },
              },
              {
                ...(userRoleID !== 'adminapp' && userRoleID !== 'Administrator'
                  ? {
                      bodega: {
                        id: { _eq: userBodega },
                      },
                    }
                  : {}),
              },
            ],
          },
        })
      );

      setSeriales(response);
      setPagination(prevPagination => ({
        ...prevPagination,
        total: total,
      }));

      // Devolver los datos cuando se solicita con limit=-1
      if (limit === -1) {
        return response;
      }
    } catch (error) {
      console.error('Error fetching seriales:', error);
      message.error('Error al cargar los seriales');
    } finally {
      setLoading(false);
    }
  };
  const agregarserial = (serial, checked, showMessage = true) => {
    if (precioselect === null) {
      message.warning('Seleccione un precio primero');
      return;
    }

    // Check if serial is already selected in any product
    const isSerialAlreadySelected = arrayproductosfacturar?.some(item =>
      item.seriales?.some(s => s.id === serial.id)
    );

    if (checked && isSerialAlreadySelected) {
      message.warning('Este serial ya ha sido seleccionado');
      return;
    }

    if (checked) {
      // If producto is not selected, select it
      if (!productoselect.id || productoselect.id !== serial.producto.id) {
        const producto = productosvendedor.find(
          p => p.id === serial.producto.id
        );

        if (producto) {
          form.setFieldsValue({
            producto: producto.id,
          });
          selecionadoproducto(producto.id);
        }
      }

      let found = arrayproductosfacturar.find(
        item => item.producto.id === serial.producto.id
      );

      if (found) {
        const serialExists = found.seriales.find(item => item.id === serial.id);
        if (!serialExists) {
          found.seriales.push(serial);
          // Show message only for individual serial additions if showMessage is true
          if (showMessage) {
            message.success(
              `Se agregó el serial del producto ${found.producto.nombre}`
            );
          }
        }
      } else {
        const selectedProduct = productosvendedor.find(
          p => p.id === serial.producto.id
        );
        arrayproductosfacturar.push({
          producto: {
            id: serial.producto.id,
            nombre: selectedProduct?.nombre || serial.producto.nombre,
            grupo: {
              impuesto: selectedProduct?.grupo?.impuesto || '0',
            },
          },
          seriales: [serial],
          precio: parseFloat(precioselect) || 0,
          esNoSerializado: false,
        });
        // Show message only for individual serial additions if showMessage is true
        if (showMessage) {
          message.success(
            `Se agregó el serial del producto ${
              selectedProduct?.nombre || serial.producto.nombre
            }`
          );
        }
      }
    } else {
      // Handle unchecking a serial
      const productIndex = arrayproductosfacturar.findIndex(
        item => item.producto.id === serial.producto.id
      );

      if (productIndex !== -1) {
        const product = arrayproductosfacturar[productIndex];
        product.seriales = product.seriales.filter(s => s.id !== serial.id);

        // If no more serials for this product, remove the product from array
        if (product.seriales.length === 0) {
          arrayproductosfacturar.splice(productIndex, 1);
        }

        if (showMessage) {
          message.success(
            `Se eliminó el serial del producto ${product.producto.nombre}`
          );
        }
      }
    }

    updateTableData();
  };

  // Modify updateTableData function to correctly handle discounts
  const updateTableData = () => {
    // First map to process individual items
    const processedItems = arrayproductosfacturar.map(item => {
      const discount = descuentos.find(
        d => d.productos && d.productos.id === item.producto.id
      );

      const impuesto = parseFloat(item.producto?.grupo?.impuesto || '0');
      const precio = parseFloat(item.precio || 0);
      const cantidad = item.esNoSerializado
        ? parseInt(item.cantidad || 0)
        : item.seriales.length;
      const descuentoPorcentaje = discount ? parseFloat(discount.descuento) : 0;

      const precioConDescuento = precio - (precio * descuentoPorcentaje) / 100;
      const subtotal = precioConDescuento * cantidad;
      const totalConImpuesto = subtotal * (1 + impuesto / 100);

      return {
        key: item.producto.id,
        producto: item.producto.nombre,
        cantidad: cantidad,
        precio: precio,
        descuento: descuentoPorcentaje,
        precioConDescuento: precioConDescuento,
        impuesto: `${impuesto}%`,
        subtotal: subtotal,
        totalConImpuesto: totalConImpuesto,
        esNoSerializado: item.esNoSerializado,
      };
    });

    // Group and combine items with same product ID
    const groupedItems = processedItems.reduce((acc, item) => {
      const existingItem = acc.find(i => i.key === item.key);

      if (existingItem) {
        // Sum quantities and recalculate totals
        existingItem.cantidad += item.cantidad;
        existingItem.subtotal += item.subtotal;
        existingItem.totalConImpuesto += item.totalConImpuesto;
      } else {
        acc.push(item);
      }

      return acc;
    }, []);

    const subtotal = groupedItems.reduce(
      (sum, item) => sum + (item.subtotal || 0),
      0
    );
    const totalFinal = groupedItems.reduce(
      (sum, item) => sum + (item.totalConImpuesto || 0),
      0
    );

    setTotalfactura(subtotal);
    setTotalConImpuestos(totalFinal);
    setProductotabla([...groupedItems]);
  };

  const addarray = async array => {
    await setProductotabla(array);
  };

  const items = [
    {
      key: '1',
      label: `Por Seriales`,
      children: (
        <Seriales
          productoselect={productoselect}
          seriales={seriales}
          setPagination={setPagination}
          current={pagination.current}
          totalpagina={pagination.total}
          agregarserial={agregarserial}
          onFetchSeriales={consultarserialesvendedor}
          loading={loading}
          arrayproductosfacturar={arrayproductosfacturar}
        />
      ),
    },
    {
      key: '2',
      label: `Por Caja`,
      children: (
        <PorCaja
          productoselect={productoselect}
          seriales={seriales}
          agregarPorCaja={agregarserial}
          onFetchSeriales={consultarserialesvendedor}
          loading={loading}
          arrayproductosfacturar={arrayproductosfacturar}
        />
      ),
    },
    {
      key: '3',
      label: `Por Caja y Grupo`,
      children: (
        <PorCajaGrupo
          productoselect={productoselect}
          seriales={seriales}
          agregarPorCajaGrupo={agregarserial}
          arrayproductosfacturar={arrayproductosfacturar}
        />
      ),
    },
  ];

  // Add a new function to handle product removal
  const handleRemoveProduct = productId => {
    const index = arrayproductosfacturar.findIndex(
      item => item.producto.id === productId
    );
    if (index > -1) {
      arrayproductosfacturar.splice(index, 1);
      updateTableData();
      message.success('Producto eliminado');
    }
  };

  // Modify columns array to show discount information
  const columns = [
    {
      title: 'Producto',
      dataIndex: 'producto',
      key: 'producto',
    },
    {
      title: 'Cantidad',
      dataIndex: 'cantidad',
      key: 'cantidad',
    },
    {
      title: 'Precio',
      dataIndex: 'precio',
      key: 'precio',
      render: value => formatPrice(value, signoMoneda),
    },
    {
      title: 'Descuento',
      dataIndex: 'descuento',
      key: 'descuento',
      render: value => (value ? `${value}%` : '0%'),
    },
    {
      title: 'Precio con Descuento',
      dataIndex: 'precioConDescuento',
      key: 'precioConDescuento',
      render: value => formatPrice(value, signoMoneda),
    },
    {
      title: 'Impuesto',
      dataIndex: 'impuesto',
      key: 'impuesto',
    },
    {
      title: 'Subtotal',
      dataIndex: 'subtotal',
      key: 'subtotal',
      render: value => formatPrice(value, signoMoneda),
    },
    {
      title: 'Total + Imp',
      dataIndex: 'totalConImpuesto',
      key: 'totalConImpuesto',
      render: value => formatPrice(value, signoMoneda),
    },
    {
      title: 'Acciones',
      key: 'action',
      render: (_, record) => (
        <Button
          type="text"
          danger
          onClick={() => handleRemoveProduct(record.key)}
        >
          Eliminar
        </Button>
      ),
    },
  ];

  // Add new helper function for credit validations

  const handleClienteChange = async clienteId => {
    try {
      const directus = await getDirectusClient();
      const response = await directus.request(
        readUsers({
          fields: [
            'id',
            'credito',
            'first_name',
            'last_name',
            'tope_credito',
            'credito_usado',
            'fecha_credito_acreditado',
            'dias_max_credito',
          ],
          filter: {
            id: { _eq: clienteId },
          },
        })
      );

      if (response && response[0]) {
        const clientData = response[0];
        setSelectedClient(clientData);

        form.setFieldsValue({ tipo_factura: undefined });
        setSelectedTipoFactura(null);

        if (!clientData.credito) {
          setSelectedTipoFactura(1);
          form.setFieldsValue({ tipo_factura: 1 });
          message.warning(
            'Este cliente no tiene crédito habilitado - solo facturas de cobro'
          );
          return;
        }

        // Check credit days if there's an active credit
        if (clientData.fecha_credito_acreditado) {
          const creditDate = moment(clientData.fecha_credito_acreditado);
          const daysElapsed = moment().diff(creditDate, 'days');

          if (daysElapsed > clientData.dias_max_credito) {
            message.warning(
              `Cliente ha superado el límite de días de crédito (${clientData.dias_max_credito} días)`
            );
          }
        }

        // Check available credit
        const currentCreditUsed = parseFloat(clientData.credito_usado || 0);
        const creditLimit = parseFloat(clientData.tope_credito || 0);
        const availableCredit = creditLimit - currentCreditUsed;

        if (availableCredit <= 0) {
          message.warning('Cliente ha alcanzado su tope de crédito');
        } else {
          message.info(
            `Crédito disponible: ${formatPrice(availableCredit, signoMoneda)}`
          );
        }
      }
    } catch (error) {
      console.error('Error checking client credit:', error);
      message.error('Error al verificar el crédito del cliente');
    }
  };

  // Add credit validation function
  const validateCredit = async (clientData, invoiceAmount) => {
    // Check if client has credit enabled
    if (!clientData.credito) {
      throw new Error('Este cliente no tiene crédito habilitado');
    }

    // Check credit limit
    const currentCreditUsed = parseFloat(clientData.credito_usado || 0);
    const creditLimit = parseFloat(clientData.tope_credito || 0);
    const newCreditTotal = currentCreditUsed + invoiceAmount;

    if (newCreditTotal > creditLimit) {
      throw new Error(
        `El cliente superaría su tope de crédito (${creditLimit.toLocaleString()})`
      );
    }

    // Check credit days if there's an active credit
    if (clientData.fecha_credito_acreditado) {
      const creditDate = moment(clientData.fecha_credito_acreditado);
      const daysElapsed = moment().diff(creditDate, 'days');

      if (daysElapsed > clientData.dias_max_credito) {
        throw new Error(
          `El cliente ha superado su límite de días de crédito (${clientData.dias_max_credito} días)`
        );
      }
    }

    return true;
  };

  // Update the Facturar function
  const Facturar = async () => {
    if (precioselect === null) {
      message.warning('Debe seleccionar un precio antes de facturar');
      return;
    }

    try {
      setLoading(true); // Activar el estado de carga
      if (!cajaAbierta) {
        Modal.error({
          title: 'Caja Cerrada',
          content: 'No puede crear facturas sin tener una caja abierta.',
        });
        setLoading(false); // Desactivar el estado de carga en caso de error
        return;
      }

      const formValues = form.getFieldsValue();

      const directus = await getDirectusClient();
      let productos = [];
      let allSeriales = [];
      let totalVenta = 0;
      const currentDate = moment().format('YYYY-MM-DDTHH:mm:ssZ');

      // Calculate total and prepare productos data
      arrayproductosfacturar.forEach(item => {
        if (item.esNoSerializado) {
          totalVenta += item.precio * item.cantidad;
          productos.push({
            cantidad: item.cantidad,
            nombre: item.producto.nombre,
            precio_unitario: item.precio,
            producto: item.producto.id,
          });
        } else {
          totalVenta += item.precio * item.seriales.length;
          productos.push({
            nombre: item.producto.nombre,
            cantidad: item.seriales.length,
            precio_unitario: item.precio,
            producto: item.producto.id,
            seriales: {
              create: [],
              update: item.seriales.map(serial => ({
                produtofactura: '+',
                id: serial.id,
              })),
              delete: [],
            },
          });
          allSeriales.push(...item.seriales.map(s => s.id));
        }
      });

      if (formValues.tipo_factura === 2) {
        try {
          const directus = getDirectusClient();
          const clientResponse = await directus.request(
            readUsers({
              fields: [
                'id',
                'credito',
                'credito_usado',
                'tope_credito',
                'fecha_credito_acreditado',
                'dias_max_credito',
              ],
              filter: { id: { _eq: formValues.cliente } },
            })
          );

          const clientData = clientResponse[0];

          if (!clientData) {
            throw new Error('Cliente no encontrado');
          }

          await validateCredit(clientData, totalConImpuestos);
        } catch (error) {
          Modal.error({
            title: 'Error de Crédito',
            content: error.message,
          });
          setLoading(false); // Desactivar el estado de carga en caso de error
          return;
        }
      }

      const complementoData = {
        factura: {
          bodega: userBodega,
          tipo: formValues.tipo_factura,
          total: totalVenta,
          caja: currentCajaId,
          cliente: formValues.cliente,
          vendedor_factura: formValues.vendedor_factura,
          vendedor_prestamo: vendedorprestamo.id,
          prefijo: 'PRE',
          fecha_facturacion: currentDate,
        },
        productos: productos.map(producto => ({
          producto: producto.producto,
          cantidad: producto.cantidad,
          nombre: producto.nombre,
          precio_unitario: producto.precio_unitario,
          seriales: producto.seriales?.update?.map(s => s.id) || [],
        })),
      };

      // Send to external URL
      const facturaResponse = await fetch(
        `${process.env.REACT_APP_URL_COMPLEMENTO}/api/facturacionweb`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(complementoData),
        }
      );

      if (!facturaResponse.ok) {
        throw new Error(`HTTP error! status: ${facturaResponse.status}`);
      }

      const facturaData = await facturaResponse.json();

      if (facturaData.factura_id) {
        // Update prestamo_usado for vendor
        await directus.request(
          updateUser(vendedorprestamo.id, {
            prestamo_usado:
              parseFloat(vendedorprestamo.prestamo_usado || 0) +
              totalConImpuestos,
          })
        );

        if (formValues.tipo_factura === 2) {
          // Convert the values to numbers and calculate the new credit
          const currentCreditUsed = parseFloat(
            selectedClient.credito_usado || 0
          );
          const newCreditAmount = parseFloat(totalConImpuestos);
          const newCreditUsed = (currentCreditUsed + newCreditAmount).toFixed(
            2
          );

          await directus.request(
            updateUser(formValues.cliente, {
              credito_usado: parseFloat(newCreditUsed),
              ...((!selectedClient.fecha_credito_acreditado ||
                selectedClient.fecha_credito_acreditado === null) && {
                fecha_credito_acreditado: currentDate,
              }),
            })
          );
        }

        // Función para procesar seriales en lotes
        const processInBatches = async (items, batchSize, processor) => {
          const results = [];
          for (let i = 0; i < items.length; i += batchSize) {
            const batch = items.slice(i, i + batchSize);
            const batchResults = await Promise.all(batch.map(processor));
            results.push(...batchResults);
          }
          return results;
        };

        // Crear historial_seriales para productos serializados en lotes
        if (allSeriales.length > 0) {
          const BATCH_SIZE = 100; // Procesar en lotes de 100 seriales
          const serialesBatches = [];

          // Dividir seriales en lotes
          for (let i = 0; i < allSeriales.length; i += BATCH_SIZE) {
            serialesBatches.push(allSeriales.slice(i, i + BATCH_SIZE));
          }

          // Procesar cada lote de seriales
          for (const serialesBatch of serialesBatches) {
            try {
              await directus.request(
                createItem('historial_seriales', {
                  tipo: 1,
                  factura_n: facturaData.factura_id,
                  seriales: {
                    create: serialesBatch.map(serialId => ({
                      historial_seriales_id: '+',
                      seriales_id: {
                        id: serialId,
                      },
                    })),
                  },
                })
              );
            } catch (error) {
              console.error(`Error procesando lote de seriales:`, error);
              throw new Error(
                `Error al procesar lote de seriales: ${error.message}`
              );
            }
          }
        }

        // Procesar productos no serializados
        const productosNoSerializados = arrayproductosfacturar.filter(
          item => item.esNoSerializado
        );
        if (productosNoSerializados.length > 0) {
          // Crear historial_seriales para productos no serializados
          const historialResponse = await directus.request(
            createItem('historial_seriales', {
              tipo: 1,
              factura_n: facturaData.factura_id,
            })
          );

          // Procesar cada producto no serializado
          for (const item of productosNoSerializados) {
            // Buscar el inventario no serializado
            const inventarioNoSerial = await directus.request(
              readItems('inventario_no_serial', {
                fields: ['*'],
                filter: { producto: { id: { _eq: item.producto.id } } },
              })
            );

            if (inventarioNoSerial && inventarioNoSerial.length > 0) {
              const inventarioNsId = inventarioNoSerial[0].id;

              // Buscar el préstamo no serializado
              const prestamoNoSerial = await directus.request(
                readItems('inventario_ns_prestamo', {
                  fields: ['*'],
                  filter: {
                    _and: [
                      { inventario_ns: { id: { _eq: inventarioNsId } } },
                      { estado: { _eq: 'prestado' } },
                    ],
                  },
                })
              );

              if (prestamoNoSerial && prestamoNoSerial.length > 0) {
                const prestamoId = prestamoNoSerial[0].id;
                const cantidadActual = prestamoNoSerial[0].cantidad;
                const cantidadAFacturar = item.cantidad;
                const nuevaCantidad = cantidadActual - cantidadAFacturar;

                await updateInventarioNSPrestamo(prestamoId, {
                  cantidad: nuevaCantidad,
                });
                await EditInventarioNoSerial(inventarioNsId, {
                  cantidad: nuevaCantidad,
                });

                // Crear detalle_historial_ns
                await directus.request(
                  createItem('detalle_historial_ns', {
                    cantidad: item.cantidad,
                    historial_seriales: {
                      create: [
                        {
                          detalle_historial_ns_id: '+',
                          historial_seriales_id: { id: historialResponse.id },
                        },
                      ],
                    },
                    prestamo_ns_p: prestamoId,
                  })
                );
              }
            }
          }
        }

        message.success('Factura creada exitosamente');
        navigate('/visualizarfactura', {
          state: {
            factura: facturaData.factura_id,
          },
        });
      }
    } catch (error) {
      console.error('Error creating factura:', error);
      Modal.error({
        title: 'Error',
        content: 'Error al crear la factura',
      });
      setLoading(false); // Desactivar el estado de carga en caso de error
    }
  };

  const cerrarCaja = () => {
    setIsCajaCloseModalVisible(true);
  };

  // Add this check before rendering tabs
  const showTabs = useMemo(() => {
    return productoselect.id && precioselect > 0;
  }, [productoselect.id, precioselect]);

  // Función para manejar la cantidad de productos no serializados
  const handleCantidadNoSerializado = value => {
    if (!productoselect || !productoselect.cantidad) {
      message.warning('Debe seleccionar un producto primero');
      return;
    }

    const cantidadDisponible = parseInt(productoselect.cantidad);
    const cantidadSolicitada = parseInt(value);

    if (cantidadSolicitada > cantidadDisponible) {
      message.warning(`La cantidad no puede superar ${cantidadDisponible}`);
      return;
    }

    setCantidadNoSerializado(cantidadSolicitada);
  };

  // Función para agregar productos no serializados
  const agregarProductoNoSerializado = () => {
    if (!productoselect || !productoselect.id) {
      message.warning('Debe seleccionar un producto primero');
      return;
    }

    if (precioselect === null || precioselect <= 0) {
      message.warning('Debe seleccionar un precio válido');
      return;
    }

    if (cantidadNoSerializado <= 0) {
      message.warning('La cantidad debe ser mayor a 0');
      return;
    }

    // Verificar si ya existe el producto en el array
    const productoExistente = arrayproductosfacturar.find(
      item => item.producto.id === productoselect.id && item.esNoSerializado
    );

    if (productoExistente) {
      const cantidadTotal =
        parseInt(productoExistente.cantidad) + parseInt(cantidadNoSerializado);
      if (cantidadTotal > parseInt(productoselect.cantidad)) {
        message.warning(
          `La cantidad total no puede superar ${productoselect.cantidad}`
        );
        return;
      }
      productoExistente.cantidad = cantidadTotal.toString();
    } else {
      arrayproductosfacturar.push({
        producto: {
          id: productoselect.id,
          nombre: productoselect.nombre,
          grupo: {
            impuesto: productoselect.grupo?.impuesto || '0',
          },
        },
        cantidad: cantidadNoSerializado.toString(),
        precio: precioselect,
        esNoSerializado: true,
      });
    }

    updateTableData();
    message.success('Producto agregado correctamente');
  };

  useEffect(() => {
    if (productoselect?.id && vendedorprestamo?.id) {
      consultarserialesvendedor();
    }
  }, [pagination.current]);

  return (
    <Layouts>
      <Form form={form} onFinish={Facturar}>
        <Row gutter={16}>
          <Col>
            {' '}
            <Form.Item
              name="vendedor"
              label="Vendedor prestamo"
              rules={[{ required: true }]}
            >
              <Select
                placeholder="Selecciona un vendedor"
                showSearch
                filterOption={false}
                onSearch={consultarVendedorprestamo}
                onChange={seleccionarvendedorprestamo}
                style={{ width: 200 }}
              >
                {vendedoresprestamo.map(vendedor => (
                  <Option
                    key={vendedor.id}
                    value={vendedor.id}
                    label={`${vendedor.first_name} ${vendedor.last_name}`}
                  >
                    {vendedor.first_name}
                    <span style={{ color: '#20c77c', fontSize: 12 }}>
                      {' '}
                      {vendedor.last_name}
                    </span>
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="vendedor_factura"
              label="Vendedor factura"
              rules={[{ required: true }]}
            >
              <Select
                placeholder="Selecciona un vendedor"
                showSearch
                filterOption={false}
                onSearch={consultarVendedorFactura}
                style={{ width: 200 }}
              >
                {vendedoresFactura.map(vendedor => (
                  <Option
                    key={vendedor.id}
                    value={vendedor.id}
                    label={`${vendedor.first_name} ${vendedor.last_name}`}
                  >
                    {vendedor.first_name}
                    <span style={{ color: '#20c77c', fontSize: 12 }}>
                      {' '}
                      {vendedor.last_name}
                    </span>
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="producto"
              label="Seleccione un producto"
              rules={[{ required: true }]}
            >
              <Select
                placeholder="Selecciona un Producto"
                filterOption={false}
                onChange={selecionadoproducto}
                style={{ width: 200 }}
              >
                {productosvendedor.map(producto => (
                  <Option key={producto.id} value={producto.id} allowClear>
                    {producto.nombre}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="precios"
              label="Seleccione precio de producto"
              rules={[{ required: true }]}
            >
              <Select
                placeholder="Selecciona un Precio"
                showSearch={true}
                filterOption={false}
                onChange={selectprecio}
                style={{ width: 200 }}
              >
                {precios.map(precio => (
                  <Option key={precio.alias} value={precio.precio}>
                    {`${precio.alias}: ${formatPrice(
                      precio.precio,
                      signoMoneda
                    )}`}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            {/* Alert que aparece si no se ha seleccionado un precio */}
            {precioselect === null && (
              <Alert
                message="Debe seleccionar un precio para continuar"
                type="warning"
                showIcon
                style={{ marginBottom: 16 }}
              />
            )}
            <Form.Item
              name="cliente"
              label="Cliente"
              rules={[
                { required: true, message: 'Por favor seleccione un cliente' },
              ]}
            >
              <Select
                placeholder="Seleccione un cliente"
                showSearch
                filterOption={false}
                onSearch={consultarClientes}
                onChange={handleClienteChange}
                style={{ width: 200 }}
              >
                {clientes.map(cliente => (
                  <Option key={cliente.id} value={cliente.id}>
                    {`${cliente.first_name} ${cliente.last_name}`}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="tipo_factura"
              label="Tipo de Factura"
              rules={[
                {
                  required: true,
                  message: 'Por favor seleccione el tipo de factura',
                },
              ]}
            >
              <Select
                placeholder="Seleccione el tipo de factura"
                value={selectedTipoFactura}
                onChange={value => setSelectedTipoFactura(value)}
                style={{ width: 200 }}
              >
                {tipoFactura.map(tipo => {
                  const isDisabled =
                    tipo.tipo === 'credito' && !selectedClient?.credito;

                  return (
                    <Option key={tipo.id} value={tipo.id} disabled={isDisabled}>
                      {tipo.tipo}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col>
            {productoselect?.esNoSerializado ? (
              <Form.Item label="Cantidad">
                <InputNumber
                  min={1}
                  max={parseInt(productoselect.cantidad)}
                  value={cantidadNoSerializado}
                  onChange={handleCantidadNoSerializado}
                />
                <Button
                  type="primary"
                  onClick={agregarProductoNoSerializado}
                  style={{ marginLeft: 8 }}
                >
                  Agregar
                </Button>
              </Form.Item>
            ) : // Mostrar Alert si no hay precio seleccionado, de lo contrario mostrar tabs
            precioselect === null ? (
              <Alert
                message="Seleccione un precio para habilitar las opciones de seriales"
                type="warning"
                showIcon
                style={{ marginBottom: 16, width: '100%' }}
              />
            ) : (
              <Tabs defaultActiveKey="1" items={items} />
            )}
          </Col>
        </Row>
        <Table
          columns={columns}
          dataSource={productotabla}
          rowKey="key" // Add this line
          pagination={false} // Optional, depending on your needs
        />
        <Row justify="end" style={{ marginTop: 16 }}>
          <Col>
            <Space
              direction="vertical"
              size="small"
              style={{ textAlign: 'right' }}
            >
              <Text>Subtotal: {formatPrice(totalfactura, signoMoneda)}</Text>
              <Text type="success">
                Total + Imp: {formatPrice(totalConImpuestos, signoMoneda)}
              </Text>
            </Space>
          </Col>
        </Row>
        <Space>
          <Button
            type="primary"
            htmlType="submit"
            disabled={!cajaAbierta}
            loading={loading}
          >
            Facturar
          </Button>
          <Button
            type="primary"
            onClick={() => setIsConsignacionModalVisible(true)}
            disabled={!cajaAbierta}
          >
            Nueva Consignación
          </Button>
          <Button onClick={cerrarCaja} disabled={!cajaAbierta} danger>
            Cerrar Caja
          </Button>
        </Space>
      </Form>
      <CajaCloseModal
        visible={isCajaCloseModalVisible}
        onClose={() => setIsCajaCloseModalVisible(false)}
        cajaId={currentCajaId}
        onCajaClosed={() => {
          setCajaAbierta(false);
          setCurrentCajaId(null);
        }}
      />
      <ConsignacionModal
        visible={isConsignacionModalVisible}
        onCancel={() => setIsConsignacionModalVisible(false)}
        currentCajaId={currentCajaId}
      />
    </Layouts>
  );
}

export default Factura;
